import React from 'react'
import { Avatar as LibAvatar } from '@centra/centra-ui'
import { TAvatarSize } from '@centra/centra-ui/dist/atoms/Avatar/models'

interface AvatarSize {
  md: string
  lg: string
  xl: string
  xxl: string
}

/**
 * Оставляю функцию тут, чтобы не экспортировать AvatarSize, чтобы он не мешал автокомплиту либы
 * местный аватр и аватаринфо все равно надо постепенно убирать вместе с переписыванием разделов.
 * В новом коде их не должно быть
 */
export const convertAvatarSizeToCentraUi = (size?: keyof AvatarSize): TAvatarSize => {
  return size
    ? {
        md: 32,
        lg: 40,
        xl: 56,
        xxl: 80,
      }[size]
    : 24
}

export type StorageType = 'company-logo' | 'product-logo' | 'product-media' | 'account-avatar' | false

export interface AvatarType {
  storage?: StorageType
  online?: boolean
  avatar?: string
  firstName?: string
  lastName?: string
  size?: keyof AvatarSize
  grayscale?: boolean
  withBg?: boolean
  progressiveImage?: boolean
}

/**
 * @deprecated
 */
const Avatar = (props: AvatarType) => {
  const size = convertAvatarSizeToCentraUi(props.size)
  return (
    <LibAvatar
      imageUrl={props.avatar}
      size={size}
      firstName={props.firstName}
      lastName={props.lastName}
      storage={props.storage || 'company-logo'}
      grayscale={props.grayscale}
      withBg={props.withBg}
      style={{ alignItems: 'center' }}
    />
  )
}

/**
 * @deprecated
 */
export default Avatar
